import { DropdownItemModel } from "@techsharegov/react-ui";

export class HtmlAgendaModel {
  id?: string;
  countyName?: string;
  meetingName?: string;
  meetingHeader?: string;
  preMeetingText?: string;
  meetingStartDisplay?: string;
  logo?: string;
  videoId?: string;
}

export class UpcomingMeetingSearchModel {
  title?: string;
  meetingDateFrom?: Date;
  meetingDateTo?: Date;
  meetingTypes?: DropdownItemModel[];
  committeeId?: string;
}
